var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('img',{staticClass:"img_auto",attrs:{"src":require("@/assets/index/map.png"),"alt":""}})])
}]

export { render, staticRenderFns }